import React from "react";
import { useSelector } from "react-redux";

export const useOptionsDropDown = (midiaId, open, setOpen) => {
  const InfoUsers = useSelector((state) => state.informationusers);
  // const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const hasStroke = [3, 9].includes(midiaId);

  const isMidiaActive = React.useMemo(() => {
    const hasUserMidias =
      Boolean(InfoUsers) &&
      Boolean(InfoUsers.user_midias) &&
      Array.isArray(InfoUsers.user_midias);
    if (!hasUserMidias) return false;
    const isThisMidiaAllowed = InfoUsers.user_midias.some(
      (midia) => midia === midiaId
    );
    return isThisMidiaAllowed;
  }, [InfoUsers]);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === "Escape") {
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  return {
    InfoUsers,
    isMidiaActive,
    hasStroke,
    anchorRef,
    open,
    handleToggle,
    handleClose,
    handleListKeyDown,
  };
};
